import { all, put, takeLeading } from 'redux-saga/effects'
import type { ApiError } from '@pbt/pbt-ui-components'

import * as API from '~/api'

import {
  fetchReminderProtocols, // Deprecated as part of CVC-15308
  fetchReminderProtocolsByPriceAndProcedure,
  fetchReminderProtocolsByPriceAndProcedureFailure,
  fetchReminderProtocolsByPriceAndProcedureSuccess,
  fetchReminderProtocolsByProcedureOnly,
  fetchReminderProtocolsByProcedureOnlyFailure,
  fetchReminderProtocolsByProcedureOnlySuccess,
  fetchReminderProtocolsFailure, // Deprecated as part of CVC-15308
  fetchReminderProtocolsSuccess, // Deprecated as part of CVC-15308
} from '../duck/reminderProtocolsV2'
import requestAPI from './utils/requestAPI'

// Deprecated as part of CVC-15308
export function* fetchReminderProtocolsSaga({
  payload,
}: ReturnType<typeof fetchReminderProtocols>) {
  try {
    const { data: reminderProtocols } = yield* requestAPI(
      API.fetchReminderProtocolsForProcedure,
      payload.priceId,
      payload.procedureId,
    )

    yield put(
      fetchReminderProtocolsSuccess({
        ...payload,
        protocols: reminderProtocols,
      }),
    )
  } catch (error) {
    yield put(fetchReminderProtocolsFailure({ error: error as ApiError }))
  }
}

export function* fetchReminderProtocolsByPriceAndProcedureSaga({
  payload,
}: ReturnType<typeof fetchReminderProtocolsByPriceAndProcedure>) {
  try {
    const { data: reminderProtocols } = yield* requestAPI(
      API.fetchReminderProtocolsForProcedureAndPrice,
      payload.priceId,
      payload.procedureId,
    )
    yield put(
      fetchReminderProtocolsByPriceAndProcedureSuccess({
        ...payload,
        protocols: reminderProtocols,
      }),
    )
  } catch (error) {
    yield put(
      fetchReminderProtocolsByPriceAndProcedureFailure({
        error: error as ApiError,
      }),
    )
  }
}

export function* fetchReminderProtocolsByProcedureSaga({
  payload,
}: ReturnType<typeof fetchReminderProtocolsByProcedureOnly>) {
  try {
    const { data: reminderProtocols } = yield* requestAPI(
      API.fetchReminderProtocolsForProcedureOnly,
      payload.procedureId,
    )
    yield put(
      fetchReminderProtocolsByProcedureOnlySuccess({
        ...payload,
        protocols: reminderProtocols,
      }),
    )
  } catch (error) {
    yield put(
      fetchReminderProtocolsByProcedureOnlyFailure({
        error: error as ApiError,
      }),
    )
  }
}

function* watchFetchReminderProtocolsByPriceAndProcedure() {
  yield takeLeading(
    fetchReminderProtocolsByPriceAndProcedure.type,
    fetchReminderProtocolsByPriceAndProcedureSaga,
  )
}

function* watchFetchReminderProtocolsByProcedure() {
  yield takeLeading(
    fetchReminderProtocolsByProcedureOnly.type,
    fetchReminderProtocolsByProcedureSaga,
  )
}

function* watchFetchReminderProtocols() {
  yield takeLeading(fetchReminderProtocols.type, fetchReminderProtocolsSaga)
}

export default function* reminderProtocolsSaga() {
  yield all([
    watchFetchReminderProtocols(),
    watchFetchReminderProtocolsByPriceAndProcedure(),
    watchFetchReminderProtocolsByProcedure(),
  ])
}
